import React, { Component } from 'react'
import request from '../../../lib/requester'
import { Loader } from "react-overlay-loader";
import "react-overlay-loader/styles.css";
import Autocomplete from '../../../component/autocomplete'

class CustomerForm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      Customer_ID: '',
      Customer_Branch: '',
      Customer_Name: '',
      Customer_NPWP: '',
      Customer_NPWP_Name: '',
      Customer_NPWP_Address: '',
      Customer_Bank: '',
      Customer_Bank_Account_No: '',
      Customer_Bank_Account_Owner: '',
      Customer_PPh_Type: '',
      Customer_PPh_Rate: '',
      Customer_PKP_Badan: '',
      Customer_Is_Exist: false,
      fileContainer: { filename: '', path: ''},
      Customer_NIK: '',
      Customer_Bank_Branch: '',
      Customer_Bank_BI_Code: '',
      Customer_Notes: '',
      Customer_Source_Flag: '',
      Customer_Address: '',
      Customer_PIC: '',
      success: '',
      lovBranch: [],
      error: [],
      Loading: false,
      Is_Update: false,
      Lov_PPh_Type: [],
      User: JSON.parse(window.localStorage.getItem('is_user'))
    }
  }

  componentDidMount = () => {
    this.getMasterData()
    this.getBranch()
    let { id } = this.props.match.params;
    if (id) {
      this.getDetailCustomer(id)
    } else {
      this.props.history.push('/setup/customer/approval-list')
    }
  }

  getBranch = () => {
    let url = '/arman/v1/general/organization'
    request.getArman(url, {
      success: function(response) {
        let { data } = response.data
        this.setState({ lovBranch: data })
      }.bind(this),
      error: function(e) {
        console.log(e)
      }.bind(this)
    })
  }

  getDetailCustomer = (id) => {
    let url = '/api/traces_chd/v1/customer/detail?id=' + id
    this.setState({ loading: true })
    request.getCHD(url, {
      success: function (response) {
        let { data } = response.data
        this.setState({
          loading: false,
          Customer_Branch: data.branch,
          Customer_ID: data.customer_id,
          Customer_Name: data.customer_name,
          Customer_NPWP: data.npwp,
          Customer_NPWP_Address: data.npwp_address,
          Customer_NPWP_Name: data.npwp_name,
          Customer_PPh_Rate: data.pph_rate,
          Customer_PPh_Type: data.pph_type,
          Customer_Bank: data.bank_name,
          Customer_Bank_Account_No: data.bank_account_no,
          Customer_Bank_Account_Owner: data.bank_account_owner,
          Customer_PKP_Badan: data.pkp_badan,
          Customer_Branch: data.branch,
          Customer_Bank_BI_Code: data.bank_bi_code,
          Customer_Bank_Branch: data.bank_branch,
          Customer_NIK: data.nik,
          Customer_Notes: data.notes,
          Customer_Source_Flag: data.source_flag,
          Customer_Address: data.customer_address,
          Customer_PIC: data.customer_pic,
          Is_Update: true,
          fileContainer: {
            filename: data.attachment_filename,
            path: data.attachment_path
          },
        })

        document.getElementById('search-0').value = data.customer_name
      }.bind(this),
      error: function (e) {
        this.setState({ loading: false })
      }.bind(this)
    })
  }

  getMasterData = () => {
    let url = '/api/traces_chd/v1/program/data-master'
    request.getCHD(url, {
      success: function (response) {
        let { ProgramPPhType } = response.data.data
        this.setState({
          Lov_PPh_Type: ProgramPPhType
        })
      }.bind(this),
      error: function (e) {
        console.log(e.message)
      }
    })
  }

  handleChangeInput = (event) => {
    let value = event.target.value;
    let name = event.target.name;
    this.setState({ [name]: value });
  };

  renderLovPPhType = () => {
    return (
      <select className="form-control" disabled={true} name="Customer_PPh_Type" value={this.state.Customer_PPh_Type} onChange={this.handleChangeInput.bind(this)}>
        <option value="">- Select PPh Type -</option>
        {
          this.state.Lov_PPh_Type.map((item, index) => (
            <option value={item.pph_type}>{item.pph_type}</option>
          ))
        }
      </select>
    )
  }

  validationForm = () => {
    let errorMsg = []
    this.setState({ error: [] })

    if (this.state.Customer_ID === '') {
      errorMsg.push('Please select customer')
    }
    if (this.state.Customer_Name === '') {
      errorMsg.push('Customer Name is required')
    }
    if (this.state.Customer_NPWP === '') {
      errorMsg.push('Customer NPWP is required')
    }
    if (this.state.Customer_NPWP_Name === '') {
      errorMsg.push('Customer NPWP Name is required')
    }
    if (this.state.Customer_NPWP_Address === '') {
      errorMsg.push('Customer NPWP Address is required')
    }

    this.setState({ error: errorMsg })
    return (errorMsg.length > 0) ? false : true
  }

  handleSubmit = () => {
    this.handleApprove('V')
  }

  showNotification = () => {
    console.log(this.state.error)
    if (this.state.success.length > 0) {
      return (
        <div className="alert alert-success" role="alert">
          <i className="fa fa-check" /> {this.state.success}
        </div>
      );
    } else if (this.state.error.length > 0) {
      return (
        <div className="alert alert-danger" role="alert">
          <ul>
            {this.state.error.map((item, index) => {
              return <li key={index}><i class="fas fa-exclamation-triangle" /> {item}</li>;
            })}
          </ul>
        </div>
      );
    }
  }

  onChangeAutocomplete = (description) => {
    let container = [];
    let param = {
      query: description,
    };

    return new Promise((resolve) => {
      request.postCHD("/api/traces_chd/v1/customer/search", param, {
        success: function (response) {
          var api_response = response.data.data;
          container = api_response.map((item, index) => {
            item.text = item.CUSTOMER_DESC;
            item.value = item.CUSTOMER_ID;
            return item;
          });
          resolve(container);
        },
        error: function (e) {
          resolve([]);
        },
      });
    });
  }

  onSelectCustomer = (item, index) => {
    // check existing customer'
    let url = '/api/traces_chd/v1/customer/detail?id=' + item.value
    this.setState({ loading: true })
    request.getCHD(url, {
      success: function (response) {
        let { data } = response.data
        this.setState({
          loading: false,
          error: data.customer_id ? ['This customer is already on the list, please add another one'] : [],
          Customer_Name: data.customer_id ? '' : item.text,
          Customer_ID: data.customer_id ? '' : item.value,
          Customer_Is_Exist: data.customer_id ? true : false
        })
      }.bind(this),
      error: function (e) {
        this.setState({ loading: false })
      }.bind(this)
    })
  }

  handleReject = () => {
    this.handleApprove('R')
  }

  handleApprove = (status) => {
    let url = '/api/traces_chd/v1/customer/validate'
    let param = {
      status: status,
      customer_id: this.state.Customer_ID,
      notes: this.state.Customer_Notes
    }

    this.setState({ loading: true })
    request.postCHD(url, param, {
      success: function(response){
        let { message } = response.data
        this.setState({ loading: false, success: message })
        window.scrollTo(0,0)

        let app = this
        window.setTimeout(() => {
          app.props.history.push('/admin/setup/customer/validate')
        }, 2000)
      }.bind(this),
      error: function(e) {
        this.setState({ loading: false })
      }.bind(this)
    })
  }

  renderAttachment = () => {
    let { fileContainer } = this.state
    if (fileContainer.filename && fileContainer.filename.length > 0) {
      return (
        <span>
          <a href={this.state.fileContainer.path}>{this.state.fileContainer.filename}</a>
        </span>
      )
    }
  }

  renderLovBranch = () => {
    let {lovBranch} = this.state
    return (
      <select className="form-control" disabled={true} name="Customer_Branch" value={this.state.Customer_Branch} onChange={this.handleChangeInput.bind(this)}>
        <option value="">- Select Branch -</option>
        {
          lovBranch.map((item, index) => (
            <option value={item.org_name}>{item.org_name}</option>
          ))
        }
        </select>
    )
  }

  render() {
    return (
      <div>
        <section className="content">
          <div className="container-fluid">
            <div className="row ml-1">
              <div className="col-lg-12 col-sx-12">
                <div className="card card-info">
                  <div className="card-header">Form Customer</div>
                  <div className="card-body">
                    {this.showNotification()}
                    <form className="">
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group row mr-1">
                            <label>Customer Name</label>
                            <Autocomplete onchange={this.onChangeAutocomplete.bind(this)} isDisabled={true} onselect={this.onSelectCustomer.bind(this)} />
                          </div>
                          <div className="form-group row mr-1">
                            <label>Customer Address</label>
                            <textarea disabled className="form-control" rows={5} name="Customer_Address" value={this.state.Customer_Address}></textarea>
                          </div>
                          {/* <div className="form-group row mr-1">
                            <label>Source Flag</label>
                            <input type="text" className="form-control" name="Customer_Source_Flag" disabled={true} value={this.state.Customer_Source_Flag} onChange={this.handleChangeInput.bind(this)} />
                          </div> */}
                          <div className="form-group row mr-1">
                            <label>NIK</label>
                            <input type="text" className="form-control" name="Customer_NIK" disabled={true} value={this.state.Customer_NIK} onChange={this.handleChangeInput.bind(this)} />
                          </div>
                          <div className="form-group row mr-1">
                            <label>NPWP</label>
                            <input type="text" className="form-control" name="Customer_NPWP" disabled={true} value={this.state.Customer_NPWP} onChange={this.handleChangeInput.bind(this)} />
                          </div>
                          <div className="form-group row mr-1">
                            <label>NPWP Name</label>
                            <input type="text" className="form-control" name="Customer_NPWP_Name" disabled={true} value={this.state.Customer_NPWP_Name} onChange={this.handleChangeInput.bind(this)} />
                          </div>
                          <div className="form-group row mr-1">
                            <label>NPWP Address</label>
                            <textarea className="form-control" rows={5} name="Customer_NPWP_Address" disabled={true} value={this.state.Customer_NPWP_Address} onChange={this.handleChangeInput.bind(this)}></textarea>
                          </div>
                          <div className="form-group row mr-1">
                            <label>Branch</label>
                            <input type="text" className="form-control" value={this.state.Customer_Branch} disabled={true} />
                            {/* { this.renderLovBranch() } */}
                          </div>
                          <div className="form-group row mr-1">
                            <label>PKP Badan</label>
                            <div class="ml-2 custom-control custom-radio">
                              <input type="radio" id="customRadio1" disabled={true} checked={this.state.Customer_PKP_Badan === 'Y' ? true : false} name="Customer_PKP_Badan" className="custom-control-input" value="Y" onClick={this.handleChangeInput.bind(this)} />
                              <label class="custom-control-label" for="customRadio1">Ya</label>
                            </div>
                            <div class="ml-2 custom-control custom-radio">
                              <input type="radio" id="customRadio2" disabled={true} checked={this.state.Customer_PKP_Badan === 'N' ? true : false} name="Customer_PKP_Badan" className="custom-control-input" value="N" onClick={this.handleChangeInput.bind(this)} />
                              <label class="custom-control-label" for="customRadio2">Tidak</label>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label>PIC</label>
                            <input disabled type="text" className="form-control" name="Customer_PIC" value={this.state.Customer_PIC} onChange={(e) => this.setState({Customer_PIC: e.target.value})} />
                          </div>
                          <div className="form-group row">
                            <label>PPh Type</label>
                            {this.renderLovPPhType()}
                          </div>
                          <div className="form-group row">
                            <label>PPh Rate</label>
                            <input type="number" className="form-control" disabled={true} name="Customer_PPh_Rate" value={this.state.Customer_PPh_Rate} onChange={this.handleChangeInput.bind(this)} />
                          </div>
                          <div className="form-group row">
                            <label>Bank Name</label>
                            <input type="text" className="form-control" disabled={true} name="Customer_Bank" value={this.state.Customer_Bank} onChange={this.handleChangeInput.bind(this)} />
                          </div>
                          <div className="form-group row">
                            <label>Bank Branch</label>
                            <input type="text" className="form-control" disabled={true} name="Customer_Bank_Branch" value={this.state.Customer_Bank_Branch} onChange={this.handleChangeInput.bind(this)} />
                          </div>
                          <div className="form-group row">
                            <label>Bank Account No</label>
                            <input type="text" className="form-control" disabled={true} name="Customer_Bank_Account_No" value={this.state.Customer_Bank_Account_No} onChange={this.handleChangeInput.bind(this)} />
                          </div>
                          <div className="form-group row">
                            <label>Bank Account Owner</label>
                            <input type="text" className="form-control" disabled={true} name="Customer_Bank_Account_Owner" value={this.state.Customer_Bank_Account_Owner} onChange={this.handleChangeInput.bind(this)} />
                          </div>
                          <div className="form-group">
                            <label>Document</label><br />
                            { this.renderAttachment() }
                          </div>
                          <div className="form-group row">
                            <label>Notes</label>
                            <textarea className="form-control" onChange={this.handleChangeInput.bind(this)} name="Customer_Notes" rows={5} value={this.state.Customer_Notes}></textarea>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-3">
                          <button type="button" className="btn btn-primary btn-block" onClick={this.handleSubmit.bind(this)}><i className="fa fa-save" /> Validate</button>
                        </div>
                        <div className="col-md-3">
                          <button type="button" className="btn btn-danger btn-block" onClick={this.handleReject.bind(this)}><i className="fa fa-times" /> Reject</button>
                        </div>
                        <div className="col-md-3">
                          <button type="button" className="btn btn-warning btn-block" onClick={() => { this.props.history.push('/admin/setup/customer/approval-list') }}><i className="fa fa-arrow-left" /> Back</button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Loader fullPage loading={this.state.loading} />
        </section>
      </div>
    )
  }
}

export default CustomerForm